import { render, staticRenderFns } from "./ReportPhysicians.vue?vue&type=template&id=32e275dd&scoped=true&"
import script from "./ReportPhysicians.vue?vue&type=script&lang=js&"
export * from "./ReportPhysicians.vue?vue&type=script&lang=js&"
import style0 from "./ReportPhysicians.vue?vue&type=style&index=0&id=32e275dd&lang=scss&scoped=true&"
import style1 from "./ReportPhysicians.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e275dd",
  null
  
)

export default component.exports